<template>
  <v-row no-gutters style="height: 100%">
    <v-card
      v-if="isFetchingWebhookInfo"
      class="d-flex flex-row justify-center align-center"
      height="250px"
      width="630px"
      flat
    >
      <loading-logo :value="200" />
    </v-card>
    <v-col cols="12" v-else>
      <v-row no-gutters v-if="step === 0">
        <v-col cols="12" class="mt-4">
          <span class="text-subtitle-2 font-weight-normal">
            {{ $t('message.pages.drm.mainSettings') }}
            <a :href="drmLink" style="text-decoration: none" target="_blank">
              {{ $t('message.pages.drm.articleAbout') }}.
            </a>
          </span>
        </v-col>
        <v-col cols="12" class="mt-4">
          <span class="text-body-2">{{
            $t('message.pages.drm.settingsForm.groupName')
          }}</span>
        </v-col>
        <v-col cols="12">
          <v-text-field
            v-model="group.name"
            outlined
            color="primary"
            hide-details
          ></v-text-field>
        </v-col>
        <v-col cols="12" class="my-3">
          <v-row no-gutters>
            <v-col cols="12">
              <v-row no-gutters>
                <span class="text-body-2"
                  >{{ $t('message.pages.drm.settingsForm.platform') }}
                </span>
                <v-icon class="ml-1" size="16" @click="helpDrmLink">
                  mdi-help-circle
                </v-icon>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="selectedSourceWebhook"
                style="width: 700px"
                :items="platformOptions"
                hide-details
                item-text="type"
                outlined
                :menu-props="{ top: false, offsetY: true }"
              >
                <template v-slot:selection="{ item }">
                  <span>
                    {{
                      item.type === 'api'
                        ? item.type.toUpperCase()
                        : capitalizeFirstLetter(item.type)
                    }}
                  </span>
                </template>
                <template v-slot:item="{ item }">
                  <span>
                    {{
                      item.type === 'api'
                        ? item.type.toUpperCase()
                        : capitalizeFirstLetter(item.type)
                    }}
                  </span>
                </template>
              </v-select>
            </v-col>
          </v-row>
        </v-col>
        <v-col
          cols="12"
          v-if="
            selectedSourceWebhook === 'api' ||
            selectedSourceWebhook === 'ticto' ||
            selectedSourceWebhook === 'memberkit'
          "
        >
          <v-row no-gutters>
            <v-col cols="12">
              <span class="text-body-2">
                {{ $t('message.pages.drm.settingsForm.groupId') }}
              </span>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="drmGroup.id"
                @click="copyLinkToClipboard(groupId)"
                outlined
                color="primary"
                readonly
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
        <v-col
          cols="12"
          v-if="
            selectedSourceWebhook === 'api' ||
            selectedSourceWebhook === 'ticto' ||
            selectedSourceWebhook === 'memberkit'
          "
          class="mt-2"
        >
          <v-row no-gutters>
            <v-col cols="12">
              <span class="text-body-2">{{
                $t('message.pages.drm.settingsForm.secretKey')
              }}</span>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="drmGroup.secret"
                :append-icon="showSecretKey ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showSecretKey ? 'text' : 'password'"
                @click:append="showSecretKey = !showSecretKey"
                @click="copyLinkToClipboard(drmGroup.secret)"
                outlined
                color="primary"
                readonly
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
        <v-col
          cols="12"
          v-else-if="
            (selectedSourceWebhook !== 'api' &&
              selectedSourceWebhook === 'hotmart') ||
            (selectedSourceWebhook !== 'api' &&
              selectedSourceWebhook === 'eduzz')
          "
        >
          <v-row no-gutters>
            <v-col cols="12">
              <v-row no-gutters>
                <span class="text-body-2">{{
                  $t('message.pages.drm.settingsForm.integrationUrl')
                }}</span>
                <v-icon class="ml-1" size="16" @click="helpDrmLink">
                  mdi-help-circle
                </v-icon>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="webhookUrl"
                append-icon="mdi-content-copy"
                type="text"
                @click:append="copyLinkToClipboard(webhookUrl)"
                @click="copyLinkToClipboard(webhookUrl)"
                outlined
                color="primary"
                readonly
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="mt-3">
              <v-row no-gutters>
                <span class="text-body-2">
                  Token de verificação
                  <b>({{ capitalizeFirstLetter(selectedSourceWebhook) }})</b>
                </span>
                <v-icon class="ml-1" size="16" @click="helpDrmLink">
                  mdi-help-circle
                </v-icon>
              </v-row>
              <v-text-field
                v-model="tokenVerification"
                class="inputHeight"
                style="width: 700px"
                outlined
                hide-details
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" class="mt-6">
              <v-divider />
            </v-col>
            <v-col cols="12" class="mt-4">
              <v-row no-gutters align="center">
                <v-col cols="12">
                  <span
                    >{{ $t('message.pages.drm.settingsForm.watermark') }}
                  </span>
                </v-col>
                <v-col cols="12" class="mt-2">
                  <v-radio-group
                    v-model="isDefaultText"
                    hide-details
                    dense
                    class="mt-0 pt-0 ml-2"
                  >
                    <v-radio
                      :label="
                        $t('message.pages.drm.settingsForm.defaultWatermark')
                      "
                      :value="true"
                    ></v-radio>
                    <v-radio
                      :label="$t('message.pages.drm.settingsForm.custom')"
                      :value="false"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <v-row no-gutters v-if="isCustomizableWebhook && !isDefaultText">
          <v-col cols="12" class="mt-4">
            <span class="text-body-2">{{
              $t('message.pages.drm.settingsForm.firstField')
            }}</span>
          </v-col>
          <v-col cols="12">
            <tip-tap
              :name="field1.name"
              :contentValue="field1.contentValue"
              :webhookFields="webhookFields"
            ></tip-tap>
          </v-col>
          <v-col cols="12" class="mt-4">
            <span class="text-body-2">{{
              $t('message.pages.drm.settingsForm.secondField')
            }}</span>
          </v-col>
          <v-col cols="12">
            <tip-tap
              :name="field2.name"
              :contentValue="field2.contentValue"
              :webhookFields="webhookFields"
            ></tip-tap>
          </v-col>
          <v-col cols="12" class="mt-4">
            <span class="text-body-2">{{
              $t('message.pages.drm.settingsForm.thirdField')
            }}</span>
          </v-col>
          <v-col cols="12">
            <tip-tap
              :name="field3.name"
              :contentValue="field3.contentValue"
              :webhookFields="webhookFields"
            ></tip-tap>
          </v-col>
        </v-row>
        <v-row no-gutters v-if="isCustomizableWebhook">
          <v-col cols="12" class="mt-6">
            <v-divider />
          </v-col>
          <v-col cols="12" class="mt-4">
            <v-row no-gutters align="center">
              <v-col cols="12">
                <span
                  >{{
                    $t('message.pages.drm.settingsForm.watermarkBooleanText')
                  }}
                </span>
              </v-col>
              <v-col cols="12" class="mt-2">
                <v-radio-group
                  v-model="isCustomizableQuestion"
                  hide-details
                  dense
                  class="mt-0 pt-0 ml-2"
                >
                  <v-radio
                    :label="
                      $t('message.pages.drm.settingsForm.defaultQuestion')
                    "
                    :value="false"
                  ></v-radio>
                  <v-radio
                    :label="$t('message.pages.drm.settingsForm.custom')"
                    :value="true"
                  ></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
          </v-col>
          <v-row no-gutters v-if="isCustomizableQuestion">
            <v-col cols="12" class="mt-4">
              <span class="text-body-2"
                >{{ $t('message.pages.drm.settingsForm.watermarkQuestion') }}
              </span>
              <v-icon class="ml-1" size="16" @click="openDrmLink">
                mdi-help-circle
              </v-icon>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="watermarkQuestion"
                outlined
                color="primary"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              class="mt-2"
              v-if="
                selectedSourceWebhook === 'ticto' ||
                selectedSourceWebhook === 'memberkit'
              "
            >
              <span>
                {{
                  $t('message.pages.drm.updateGroup.articleLinkAbout', {
                    company: capitalizeFirstLetter(selectedSourceWebhook),
                  })
                }}
                <a @click="helpDrmLink">{{
                  $t('message.pages.drm.updateGroup.articleAbout')
                }}</a>
              </span>
            </v-col>
          </v-row>
        </v-row>
      </v-row>
      <v-row no-gutters align="center" justify="center" v-else>
        <v-col cols="12" class="mt-2">
          <v-btn text class="mx-0 px-1" @click="goBack">
            <v-icon>mdi-chevron-left</v-icon>
            {{ $t('message.actions.return') }}
          </v-btn>
        </v-col>
        <v-card class="mt-2" height="195" width="420" flat>
          <v-img eager src="@/assets/onboardingImage3.svg" />
        </v-card>
        <span class="text-h5 mt-6">{{
          $t('message.pages.drm.settings.publishedWebhook')
        }}</span>
        <span class="text-subheading text-center mt-2 px-5">
          {{ $t('message.pages.drm.settings.webhookText') }}
          <a :href="drmLink" style="text-decoration: none" target="_blank">
            {{ $t('message.pages.drm.articleAbout') }}.
          </a>
        </span>
        <v-col cols="12" class="d-flex align-center justify-center mt-2">
          <span v-if="fetchKeysOnce && !testKeyCreated">
            {{ $t('message.pages.drm.settings.webhookRefreshing') }}
            <v-progress-circular
              class="ml-1"
              size="16"
              width="2"
              indeterminate
              color="primary"
            ></v-progress-circular>
          </span>
        </v-col>
        <v-col cols="12">
          <v-row no-gutters justify="center" align="center" class="mt-4">
            <v-btn
              color="primary"
              :loading="fetchingConfirmWebhook"
              :disabled="fetchingConfirmWebhook"
              width="200px"
              @click="handleConfirmWebhook(true)"
            >
              {{ $t('message.pages.drm.settings.confirmWebhook') }}
            </v-btn>
          </v-row>
        </v-col>
        <v-col cols="12">
          <v-alert
            v-if="!fetchingConfirmWebhook && fetchKeysOnce && testKeyCreated"
            dense
            text
            type="success"
            class="mt-6"
          >
            <span>
              {{ $t('message.pages.drm.settings.confirmWebhookTest') }}
            </span>
          </v-alert>
          <v-alert
            v-if="fetchKeysOnce && !testKeyCreated"
            dense
            outlined
            type="warning"
            class="mt-4"
          >
            <span>
              {{ $t('message.pages.drm.settings.errorWebhookConfirm') }}
            </span>
          </v-alert>
        </v-col>
      </v-row>
    </v-col>
    <v-col
      v-if="!isFetchingWebhookInfo"
      cols="12"
      class="d-flex justify-end align-end pb-4 mt-4"
    >
      <v-card width="100%" flat>
        <v-card-actions>
          <v-spacer />
          <v-btn
            min-width="140px"
            text
            class="mr-2"
            :disabled="isFetching"
            @click="handleCloseModal"
          >
            {{ $t('message.cancel') }}
          </v-btn>
          <v-btn
            v-if="step === 0"
            min-width="140px"
            color="primary"
            :disabled="isFetching || !hasFilledMinimunFields || !hasEditDrmPerm"
            :loading="isFetching"
            @click="handleConfirm"
          >
            <span class="mx-2"> {{ $t('message.actions.save') }} </span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import LoadingLogo from '@/components/LoadingLogo.vue'
import drmApi from '@/services/drmApi'
import { mapMutations } from 'vuex'
import TipTap from '../Tiptap.vue'

import {
  DRM_LINK_PT_BR,
  DRM_LINK_EN_US,
  DRM_HOTMART_LINK,
  DRM_EDUZZ_LINK,
  DRM_TICTO_LINK,
  DRM_MEMBERKIT_LINK,
} from '@/config/envs'

export default {
  name: 'DrmMainSettings',
  components: {
    LoadingLogo,
    TipTap,
  },
  props: {
    drmGroup: Object,
    handleCloseModal: Function,
  },
  data: () => ({
    isFetching: false,
    isFetchingWebhookInfo: false,
    groupdId: '',
    group: {
      name: '',
    },
    selectedSourceWebhook: 'api',
    webhookFields: [],
    listSourceWebhooks: [],
    startWebhookValue: {},
    tokenVerification: '',
    field1: {
      name: 'field1',
      contentValue: [],
      savedValue: '',
    },
    field2: {
      name: 'field2',
      contentValue: [],
      savedValue: '',
    },
    field3: {
      name: 'field3',
      contentValue: [],
      savedValue: '',
    },
    step: 0,
    fetchingConfirmWebhook: false,
    fetchKeysOnce: false,
    testKeyCreated: false,
    hasFetched: false,
    isDefaultText: true,
    showSecretKey: false,
    isCustomizableQuestion: false,
    watermarkQuestion: '',
  }),
  computed: {
    hasEditDrmPerm() {
      return (
        this.$store.state.user.userPermissions?.includes('put-watermark') ??
        false
      )
    },
    isLocalePT_BR() {
      return this.$i18next.resolvedLanguage === 'pt'
    },
    drmLink() {
      return this.isLocalePT_BR ? DRM_LINK_PT_BR : DRM_LINK_EN_US
    },
    eduzzLink() {
      return DRM_EDUZZ_LINK
    },
    hotmartLink() {
      return DRM_HOTMART_LINK
    },
    tictoLink() {
      return DRM_TICTO_LINK
    },
    memberkitLink() {
      return DRM_MEMBERKIT_LINK
    },
    platformOptions() {
      let options = [{ type: 'api' }, { type: 'memberkit' }, { type: 'ticto' }]
      return options.concat(this.listSourceWebhooks)
    },
    isCustomizableWebhook() {
      return (
        this.selectedSourceWebhook !== 'api' &&
        this.selectedSourceWebhook !== 'memberkit' &&
        this.selectedSourceWebhook !== 'ticto'
      )
    },
    webhookUrl() {
      return `https://api-v2.pandavideo.com.br/drm/webhook/${this.drmGroup.id}`
    },
    hasFilledMinimunFields() {
      if (
        this.selectedSourceWebhook === 'api' ||
        this.selectedSourceWebhook === 'ticto' ||
        this.selectedSourceWebhook === 'memberkit'
      ) {
        return this.group.name.length > 2
      } else {
        return this.tokenVerification.length > 3 && this.group.name.length > 2
      }
    },
  },
  mounted() {
    if (!this.hasFetched) {
      this.resetData()
    }
    this.$root.$on('resetDrmMainSettings', () => {
      this.resetData()
    })
    this.$root.$on('updateFieldValue', (fieldName, value) => {
      this[fieldName].savedValue = this.fixTiptapText(
        value?.content[0]?.content
      )
    })
  },
  watch: {
    selectedSourceWebhook: {
      handler(val) {
        this.changeWebhookSourceContent(val)
      },
    },
  },
  methods: {
    ...mapMutations('user', [
      'UPDATE_GLOBAL_SNACKBAR',
      'UPDATE_SHOULD_FETCH_ALL_VIDEOS',
    ]),
    openDrmLink() {
      window.open(this.drmLink, '_blank')
    },
    helpDrmLink() {
      if (this.selectedSourceWebhook === 'api')
        return window.open(this.drmLink, '_blank')
      if (this.selectedSourceWebhook === 'hotmart')
        return window.open(this.hotmartLink, '_blank')
      if (this.selectedSourceWebhook === 'eduzz')
        return window.open(this.eduzzLink, '_blank')
      if (this.selectedSourceWebhook === 'memberkit')
        return window.open(this.memberkitLink, '_blank')
      if (this.selectedSourceWebhook === 'ticto')
        return window.open(this.tictoLink, '_blank')
    },
    setSavedValues() {
      this.$root.$emit(`getValue-${this.field1.name}`)
      this.$root.$emit(`getValue-${this.field2.name}`)
      this.$root.$emit(`getValue-${this.field3.name}`)
    },
    fixTiptapText(value) {
      let res = ''
      let editorValues = value
      if (!editorValues) return res
      for (let value of editorValues) {
        if (value.type === 'mention') {
          let variableText = this.webhookFields.find((field) => {
            return field.title === value.attrs.id
          })
          let val = `###${variableText.path}###`
          res += val
        } else {
          res += ` ${value.text}`
        }
      }
      return res.trim()
    },
    fixResponseToTiptap(fieldText) {
      let res = []
      let fields = fieldText.split('###')
      for (let searchField of fields) {
        if (searchField.includes('$.')) {
          let fieldObject = this.webhookFields.find((field) => {
            return field.path === searchField
          })
          if (fieldObject) {
            let obj = {
              type: 'mention',
              attrs: {
                id: fieldObject.title,
                label: null,
              },
            }
            res.push(obj)
          }
        } else {
          if (searchField.length > 0) {
            let obj = {
              type: 'text',
              text: searchField,
            }
            res.push(obj)
          }
        }
      }
      return res
    },
    resetData() {
      Object.assign(this.$data, this.initialState())
      this.fetchData()
    },
    capitalizeFirstLetter(val) {
      return val.charAt(0).toUpperCase() + val.slice(1)
    },
    setDefaultValues() {
      this.field1.contentValue = [
        {
          type: 'text',
          text: 'Licenciado para',
        },
      ]
      this.field1.savedValue = this.fixTiptapText(this.field1.contentValue)
      let mentionIdField2 = ''
      if (this.selectedSourceWebhook === 'hotmart') {
        mentionIdField2 = 'E-mail'
      } else if (this.selectedSourceWebhook === 'eduzz') {
        mentionIdField2 = 'Nome'
      }
      this.field2.contentValue = [
        {
          type: 'mention',
          attrs: {
            id: mentionIdField2,
            label: null,
          },
        },
      ]
      this.field2.savedValue = this.fixTiptapText(this.field2.contentValue)
      let mentionIdField3 = ''
      let field3Content = []
      if (this.selectedSourceWebhook === 'hotmart') {
        mentionIdField3 = 'Nome do Produto'
      } else if (this.selectedSourceWebhook === 'eduzz') {
        field3Content = [
          {
            type: 'text',
            text: 'CPF: ',
          },
        ]
        mentionIdField3 = 'CPF'
      }
      field3Content.push({
        type: 'mention',
        attrs: {
          id: mentionIdField3,
          label: null,
        },
      })
      this.field3.contentValue = field3Content
      this.field3.savedValue = this.fixTiptapText(this.field3.contentValue)
    },
    resetInputValues() {
      this.tokenVerification = ''
      this.field1.savedValue = ''
      this.field1.contentValue = []
      this.field2.savedValue = ''
      this.field2.contentValue = []
      this.field3.savedValue = ''
      this.field3.contentValue = []
    },
    changeWebhookSourceContent(sourceWebhook) {
      this.selectedSourceWebhook = sourceWebhook
      this.resetInputValues()
      let lowerCasedSourceWebhook = sourceWebhook.toLowerCase()
      if (
        lowerCasedSourceWebhook === 'api' ||
        lowerCasedSourceWebhook === 'ticto' ||
        lowerCasedSourceWebhook === 'memberkit'
      ) {
        return
      }
      if (sourceWebhook.length) {
        this.sourceSecondStep = true
        let selectedWebhook = this.listSourceWebhooks.find(
          (el) => el.type === sourceWebhook
        )
        this.webhookFields = selectedWebhook.fields
      }
      if (sourceWebhook === this.startWebhookValue.source_name) {
        if (this.startWebhookValue.model_string1) {
          this.field1.contentValue = this.fixResponseToTiptap(
            this.startWebhookValue.model_string1
          )
          this.field1.savedValue = this.startWebhookValue.model_string1
        }
        if (this.startWebhookValue.model_string2) {
          this.field2.contentValue = this.fixResponseToTiptap(
            this.startWebhookValue.model_string2
          )
          this.field2.savedValue = this.startWebhookValue.model_string2
        }
        if (this.startWebhookValue.model_string3) {
          this.field3.contentValue = this.fixResponseToTiptap(
            this.startWebhookValue.model_string3
          )
          this.field3.savedValue = this.startWebhookValue.model_string3
        }
        if (this.startWebhookValue.source_name)
          this.selectedSourceWebhook = this.startWebhookValue.source_name
        if (this.startWebhookValue.token_verification)
          this.tokenVerification = this.startWebhookValue.token_verification
      } else {
        this.setDefaultValues()
      }
    },
    goBack() {
      this.step = 0
    },
    async fetchData() {
      this.isFetchingWebhookInfo = true
      this.groupId = this.drmGroup.id
      this.group.name = this.drmGroup.name || ''
      this.watermarkQuestion =
        this.drmGroup.config_player?.watermark_question ??
        'Digite sua senha de acesso'
      if (this.watermarkQuestion != 'Digite seu e-mail para liberar o vídeo') {
        this.isCustomizableQuestion = true
      }
      this.hasFetched = true
      await this.getSourceWebhooks()
      await this.getUserWebhooks()
      this.isFetchingWebhookInfo = false
    },
    async getUserWebhooks() {
      try {
        let ret = await drmApi.listGroupWebhooks(this.groupId)
        this.startWebhookValue = ret.data
        if (ret.data.model_string1) {
          this.field1.contentValue = this.fixResponseToTiptap(
            ret.data.model_string1
          )
          this.field1.savedValue = ret.data.model_string1
        }
        if (ret.data.model_string2) {
          this.field2.contentValue = this.fixResponseToTiptap(
            ret.data.model_string2
          )
          this.field2.savedValue = ret.data.model_string2
        }
        if (ret.data.model_string3) {
          this.field3.contentValue = this.fixResponseToTiptap(
            ret.data.model_string3
          )
          this.field3.savedValue = ret.data.model_string3
        }
        if (ret.data.source_name)
          this.selectedSourceWebhook = ret.data.source_name
        if (ret.data.token_verification)
          this.tokenVerification = ret.data.token_verification
        this.changeWebhookSourceContent(ret.data.source_name)
      } catch (e) {
        this.isFetchingWebhookInfo = false
        console.log('e', e)
      }
    },
    async handleConfirmWebhook(wasUserClick) {
      this.fetchingConfirmWebhook = true
      this.fetchKeysOnce = true
      let dataObject = {
        drm_group_id: this.drmGroup.id,
      }
      try {
        let ret = await drmApi.getDrmPrivateTokens(dataObject)
        if (ret.data.tokens.length) {
          this.testKeyCreated = true
        } else {
          this.testKeyCreated = false
          if (!wasUserClick) {
            setTimeout(() => this.handleConfirmWebhook(), 10000)
          }
        }
      } catch (e) {
        console.error(e)
      }
      this.fetchingConfirmWebhook = false
    },
    async getSourceWebhooks() {
      try {
        let ret = await drmApi.listSourceWebhooks(this.groupId)
        this.listSourceWebhooks = ret.data
      } catch (e) {
        this.isFetchingWebhookInfo = false
        console.log('e', e)
      }
    },
    async handleConfirm() {
      this.isFetching = true
      await Promise.all([this.handleUpdateWebhook(), this.handleEdit()])
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: 'Alterações publicadas com sucesso!',
      })
      this.isFetching = false
    },
    async handleUpdateWebhook() {
      this.setSavedValues()
      let webhookObj = {
        model_string1: this.field1.savedValue ? this.field1.savedValue : '',
        model_string2: this.field2.savedValue ? this.field2.savedValue : '',
        model_string3: this.field3.savedValue ? this.field3.savedValue : '',
        token_verification: this.tokenVerification,
        source_name: this.selectedSourceWebhook,
      }
      try {
        let ret = await drmApi.updateGroupWebhook(webhookObj, this.groupId)
        if (this.startWebhookValue.source_name != this.selectedSourceWebhook) {
          this.step = 1
          this.handleConfirmWebhook()
        }
        this.startWebhookValue = { ...this.startWebhookValue, ...ret.data }
      } catch (e) {
        console.log('e', e)
      }
    },
    async handleEdit() {
      let groupObject = {
        name: this.group.name,
        watermark_question: this.watermarkQuestion,
      }
      try {
        let ret = await drmApi.drmUpdateVideos(this.groupId, groupObject)
        this.$root.$emit('updateDrmGroup', ret.data)
        this.UPDATE_SHOULD_FETCH_ALL_VIDEOS(true)
      } catch (e) {
        console.log('e', e)
      }
    },
    copyLinkToClipboard(itemToBeCopied) {
      navigator.clipboard.writeText(itemToBeCopied)
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: 'Link copiado com sucesso!',
      })
    },
    initialState() {
      return {
        isFetching: false,
        isFetchingWebhookInfo: false,
        groupdId: '',
        group: {
          name: '',
        },
        selectedSourceWebhook: 'api',
        webhookFields: [],
        listSourceWebhooks: [],
        startWebhookValue: {},
        tokenVerification: '',
        field1: {
          name: 'field1',
          contentValue: [],
          savedValue: '',
        },
        field2: {
          name: 'field2',
          contentValue: [],
          savedValue: '',
        },
        field3: {
          name: 'field3',
          contentValue: [],
          savedValue: '',
        },
        step: 0,
        fetchingConfirmWebhook: false,
        fetchKeysOnce: false,
        testKeyCreated: false,
        hasFetched: false,
        isDefaultText: true,
        showSecretKey: false,
        isCustomizableQuestion: false,
        watermarkQuestion: 'Digite sua senha de acesso',
      }
    },
  },
}
</script>

<style scoped lang="less">
.pointerCursor {
  cursor: pointer;
}

.removeBorderField > .v-input__control > .v-input__slot:before {
  border-style: none !important;
}

.removeBorderField > .v-input__control > .v-input__slot:after {
  border-style: none !important;
}

.textCursor {
  cursor: text;
}

.floating-card {
  position: fixed !important;
  z-index: 10;
}

.inputHeight .v-input__control {
  min-height: 30px !important;
}

.tiptapClass {
  margin-top: 20px;
  padding: 15px 5px 5px 5px !important;
  border: 1px solid rgb(158 158 158);
  border-radius: 5px;
}
</style>
